export default "__VITE_ASSET__CcRgAbeH__"